export const ADDONS_ANNOUNCEMENT_BANNER = {
  key: 'addons-announcement',
  version: '2026-07-17', // bump this to re-show the banner to admins who already dismissed it
}
